import React, { Component } from 'react'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import Typography from '../../UI/Typography'
import Select from '../../UI/Form/Select'
import ScrollNav from '../../UI/ScrollNav'
import SplitSection from '../../UI/Slider/SplitSection'
import PriceSection from '../../UI/Misc/Price'
import TabSlider from '../../UI/TabSlider'
import { fetchDurations, fetchProducts } from '../../../actions/calculator'
import { device } from '../../../utils/helpers'
import { Element, Events } from 'react-scroll'

import Feature from '../../UI/Feature'
import TransportoIcon from '../../UI/Icons/Transporto'
import MontaggioIcon from '../../UI/Icons/Montaggio'
import QualitaIcon from '../../UI/Icons/Qualita'
import InnovazioneIcon from '../../UI/Icons/Innovazione'

import TransenneIcon from '../../UI/Icons/TransenneIcon'
import GiraffeIcon from '../../UI/Icons/GiraffeIcon'
import AmericanaIcon from '../../UI/Icons/AmericanaIcon'
import RetiIcon from '../../UI/Icons/RetiIcon'

import {
  transenneSlides1,
  transenneSlides2,
  giraffeSlides1,
  giraffeSlides2,
  americaneSlides,
  retiSlides
} from '../../Helpers/Slides'

import {
  Section,
  Title,
  BigTitle,
  FeatureWrapper,
  Features,
  Menu,
  Content
} from './Altre'

const Icon = ({ icon, ...props }) => (
  // Needed to pass props to the element which is also being
  // passed as props
  React.cloneElement(icon, { ...props })
)

export const StyledIcon = styled(Icon)`
  width: ${props => props.width};
  height: ${props => props.height};

  @media ${device.tablet} {
    width: ${props => props.tabWidth};
    height: ${props => props.tabHeight};
  }
`

export const features = [
  {
    icon: <StyledIcon icon={<TransportoIcon />} width='142px' tabWidth='7.395833333333334vw' fill='#fca317' />,
    title: 'TRASPORTO',
    description: 'Incluso nel nostro preventivo'
  },
  {
    icon: <StyledIcon icon={<MontaggioIcon />} width='110px' tabWidth='5.729166666666667vw' fill='#fca317' />,
    title: 'MONTAGGIO',
    description: 'Certificato ed effettuato da un team di esperti'
  },
  {
    icon: <StyledIcon icon={<QualitaIcon />} width='65px' tabWidth='3.385vw' fill='#fca317' />,
    title: 'QUALITÀ',
    description: 'Costruite con i migliori materiali e certificate'
  },
  {
    icon: <StyledIcon icon={<InnovazioneIcon />} width='65px' tabWidth='3.385vw' fill='#fca317' />,
    title: 'INNOVAZIONE',
    description: 'Studiate per la massima performance'
  }
]

const navItems = [
  {
    name: 'Transenne',
    icon: <StyledIcon icon={<TransenneIcon />} width='75px' height='75px' tabWidth='3.90625VW' tabHeight='3.90625VW' fill='#4d4d4d' />
  },
  {
    name: 'Giraffe',
    icon: <StyledIcon icon={<GiraffeIcon />} width='75px' height='75px' tabWidth='3.90625VW' tabHeight='3.90625VW' fill='#4d4d4d' />
  },
  {
    name: 'Americana',
    icon: <StyledIcon icon={<AmericanaIcon />} width='75px' height='75px' tabWidth='3.90625VW' tabHeight='3.90625VW' fill='#4d4d4d' />
  },
  {
    name: 'Reti',
    icon: <StyledIcon icon={<RetiIcon />} width='75px' height='75px' tabWidth='3.90625VW' tabHeight='3.90625VW' fill='#4d4d4d' />
  }
]

export const transenne = {
  description: 'Abbiamo ideato e realizzato un nuovo concept di transenne ad hoc per eventi temporanei. Il prodotto unisce alla solidità e sicurezza la capacità di massimizzare la visibilità degli sponsor tramite un meccanismo a inserimento scorrevole di banner brandizzabili.',
  technical: [
    'Dimensioni singola transenna: 195×95 cm',
    'Materiale: ferro con trattamento fondo antiruggine e verniciatura nero opaco',
    'Pannelli interni e esterni a inserimento 3mm di spessore',
    'Montaggio con certificazione statica e ove necessario di resistenza al vento (su richiesta)',
    'Morsetti in ferro e trattamento antiruggine per stabilizzare e unire più transenne tra loro',
    'Verniciatura con colore a scelta delle transenne (su richiesta)',
    'Transenne antipanico (su richiesta)'
  ],
  tabs: [
    {
      title: 'TNT',
      content: 'Brandizzazione in bobina TNT (h 2.00 m). Il TNT avvolge interamente la transenna creando un effetto omogeneo e continuo per tutta l’estensione dei metri lineari dell’installazione.',
      goToSlideIndex: 2
    },
    {
      title: 'Pannelli PVC',
      content: 'Brandizzazione con pannelli PVC da 3 mm di spessore. Grazie al nuovo meccanismo a inserimento scorrevole il tempo di brandizzazione delle transenne sull’evento è ridotto e la qualità della stampa è di alto livello.',
      goToSlideIndex: 0
    }
  ]
}

const giraffe = {
  description: 'Le “giraffe” di Noleggiocampi.it sono realizzate per una duplice funzione. Grazie alla loro particolare angolatura permettono di sostenere le reti di protezione per la fuori uscita dei palloni restando a distanza di sicurezza dall’area di gioco. Inoltre la loro solidità permette di sostenere l’impianto di illuminazione per i campi durante le partite in notturna.',
  technical: [
    'Dimensioni singola “giraffa”: 300x20 cm',
    'Materiale: ferro con trattamento fondo antiruggine e verniciatura nero opaco',
    'Montaggio con certificazione statica e ove necessario di resistenza al vento (su richiesta)',
    'Morsetti in ferro e trattamento antiruggine per stabilizzare e unire le giraffe con le transenne',
    'Verniciatura con colore a scelta delle giraffe (su richiesta)'
  ],
  tabs: [
    {
      title: 'ADESIVO',
      content: 'Possibilità di brandizzazione della parte interna delle giraffe con l’applicazione di un adesivo monomerico opaco/lucido resistente all’acqua',
      goToSlideIndex: 0
    }
  ]
}

export const americane = {
  description: 'Noleggiocampi.it dispone di diversi metri lineari di americana Eurotruss in alluminio ideale sia per la costruzione di ring perimetrali ai campi da gioco sia per il sostegno di attrezzature complementari (ledwall, grafiche, impianto audio e luci etc.)',
  technical: [
    'Americana Eurotruss alluminio (anno 2017)',
    'Sezione 30x30 cm, tralicci, basi e raccordi',
    'Materiali dotati di certificazione',
    'Montaggio con certificazione statica e, ove necessario, di resistenza al vento (su richiesta)'
  ]
}

export const reti = {
  description: 'Una rete solida e ben ancorata è fondamentale per campi che necessitino una protezione alla fuoriuscita del pallone. Requisito frequentemente richiesto per garantire i parametri minimi di sicurezza.',
  technical: [
    'Materiali dotati di certificazione',
    'Reti in polietilene trattate ai raggi UV',
    'Maglia 120×120 mm',
    'Diametro fili 3,5 mm'
  ]
}

const UList = styled.ul`
  font-size: 21px;
  padding: 0 1.2rem;

  @media ${device.laptop} {
    font-size: 16px;
  }

  @media ${device.laptopM} {
    column-count: 2;
    column-gap: 40px;
    list-style: outside disc;
  }

  @media ${device.laptopL} {
    font-size: 21px;
    column-gap: 50px;
  }
`

const ListItem = styled.li`

`

const Customize = styled.div`
  padding-top: 3rem;

  @media ${device.laptop} {
    padding-top: 1rem;
  }

  @media ${device.laptopL} {
    padding-top: 3rem;
  }
`

const CustomizeHeading = styled.p`
  font-size: 24px;
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  padding: 1.2rem 0;

  @media ${device.laptop} {
    padding: 0.5rem 0;
  }

  @media ${device.laptopL} {
    padding: 1.2rem 0;
  }
`

const CustomizeOptions = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 1.2rem 0;

  @media ${device.laptop} {
    padding: 0.5rem 0;
  }

  @media ${device.laptopL} {
    padding: 1.2rem 0;
  }
`

const FormGroup = styled.div`
  display: flex;
  padding: ${props => props.padding};
  padding-bottom: 20px;

  @media ${device.tablet} {
    width: 30%;
  }
`

class Contenimento extends Component {
  constructor (props) {
    super(props)
    this.state = {
      sticky: false,
      quantitaOptions: [],
      currentQuantita: {},
      currentDuration: {},
      addonOptions: [],
      currentAddon: {
        id: 1,
        name: 'NESSUNA',
        amount: 0
      },
      amount: 0
    }
  }

  componentDidMount () {
    Events.scrollEvent.register('begin', function () {
      console.log('begin', arguments)
    })

    Events.scrollEvent.register('end', function () {
      console.log('end', arguments)
    })

    this.props.fetchDurations(null, (durations) => {
      this.setState({ currentDuration: durations[0] })
    })
    this.props.fetchProducts((products) => {
      let transenneProducts = products.filter(product => product.name.includes('transenne'))
      transenneProducts = transenneProducts.map(product => {
        product.name = product.name.split(' ')[2]
        return product
      })
      let addonOptions = [{
        id: 1,
        name: 'NESSUNA',
        amount: 0
      }]
      transenneProducts[0].addons.map((item, i) => {
        if (item.amount) {
          addonOptions.push({
            id: i + 2,
            name: item.name,
            amount: item.amount
          })
        }
      })
      console.log(addonOptions)
      this.setState({ currentQuantita: transenneProducts[0], quantitaOptions: transenneProducts, addonOptions })
    })

    window.addEventListener('scroll', this.handleScroll.bind(this))
  }

  handleScroll (event) {
    const sticky = this.menu && this.menu.offsetTop
    if (window.pageYOffset > sticky - 100) {
      this.setState({ sticky: true })
    }

    if (window.pageYOffset < 165) {
      this.setState({ sticky: false })
    }
  }

  handleQuantitySelection (item) {
    const { currentDuration, currentAddon } = this.state
    // (Base amount + currently selected addon else 0) * quantity * currently selected duration
    let baseAmount = (item.amount + (currentAddon ? currentAddon.amount : 0))
    let amount = baseAmount + (baseAmount * currentDuration.coefficient)
    let addonOptions = [{
      id: 1,
      name: 'NESSUNA',
      amount: 0
    }]
    item.addons.map((option, i) => {
      if (option.amount) {
        addonOptions.push({
          id: i + 2,
          name: option.name,
          amount: option.amount
        })
      }
    })
    this.setState((prevState) => ({
      currentQuantita: item, amount, addonOptions
    }))
  }

  handleDurationSelection (item) {
    const { currentQuantita, currentAddon } = this.state
    // (Base amount + currently selected addon else 0) * quantity * currently selected duration
    let baseAmount = (currentQuantita.amount + (currentAddon ? currentAddon.amount : 0))
    let amount = baseAmount + (baseAmount * item.coefficient)
    this.setState((prevState) => ({
      currentDuration: item, amount
    }))
  }

  handleAddonSelection (item) {
    const { currentQuantita, currentDuration } = this.state
    let baseAmount = (currentQuantita.amount + (item ? item.amount : 0))
    // (Base amount + currently selected addon else 0) * quantity * currently selected duration
    let amount = baseAmount + (baseAmount * currentDuration.coefficient)
    this.setState((prevState) => ({
      currentAddon: item, amount
    }))
  }

  render () {
    const { durations } = this.props
    const { quantitaOptions, addonOptions } = this.state
    return (
      <div>
        <Helmet>
          <title>Noleggio Transenne Traliccio Americana Recinzione Campo Calcetto</title>
          <meta name='Description' content='Offriamo una vasta gamma di attrezzature sportive per rendere completo il tuo noleggio: Transenne metalliche, Americana Struttura, Recinzione campo calcetto' />
          <meta name='Keywords' content='traliccio americana,transenne metalliche,recinzione campo calcetto prezzi' />
        </Helmet>
        <Title>
          <Typography variant='h1' type='title'>STRUTTURE DI CONTENIMENTO</Typography>
        </Title>
        <Menu innerRef={menu => (this.menu = menu)} className={this.state.sticky ? 'sticky' : ''}>
          <ScrollNav items={navItems} />
        </Menu>
        <Content>
          {/* TRANSENNE */}
          <Element name='transenne' >
            <SplitSection slides={transenneSlides1} reverse reverseMobile>
              <Typography variant='h2' type='title'>TRANSENNE</Typography>
              <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
                {transenne.description}
              </Typography>
              <Typography padding='1.2rem 0' variant='h3' type='title'>SCHEDA TECNICA</Typography>
              <UList>
                {transenne.technical.map((item, i) => <ListItem key={i}>{item}</ListItem>)}
              </UList>
            </SplitSection>
            <TabSlider
              slides={transenneSlides2}
              tabs={transenne.tabs}
              title='Personalizzazione'
              customize
            >
              <Customize>
                <CustomizeHeading>NOLEGGIA LE TRANSENNE</CustomizeHeading>
                <CustomizeOptions>
                  <FormGroup padding='0 10px 0 0'>
                    <Select
                      title='Quantita'
                      list={quantitaOptions}
                      default={quantitaOptions[0]}
                      selected={this.handleQuantitySelection.bind(this)}
                    />
                  </FormGroup>
                  <FormGroup padding='0 10px 0 0'>
                    <Select
                      title='Durata'
                      list={durations}
                      default={durations[0]}
                      selected={this.handleDurationSelection.bind(this)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Select
                      title='Personalizzazione'
                      list={addonOptions}
                      default={this.state.currentAddon}
                      selected={this.handleAddonSelection.bind(this)}
                    />
                  </FormGroup>
                  <PriceSection
                    product={this.state.currentQuantita}
                    quantity={this.state.currentQuantita}
                    duration={this.state.currentDuration}
                    addon={this.state.currentAddon}
                    amount={this.state.amount}
                  />
                </CustomizeOptions>
              </Customize>
            </TabSlider>
          </Element>
          {/* GIRAFFE */}
          <Element name='giraffe' >
            <SplitSection slides={giraffeSlides1} reverse>
              <Typography variant='h2' type='title'>GIRAFFE</Typography>
              <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
                {giraffe.description}
              </Typography>
              <Typography padding='1.2rem 0' variant='h3' type='title'>SCHEDA TECNICA</Typography>
              <UList>
                {giraffe.technical.map((item, i) => <ListItem key={i}>{item}</ListItem>)}
              </UList>
            </SplitSection>
            <TabSlider
              slides={giraffeSlides2}
              tabs={giraffe.tabs}
              title='Personalizzazione'
            />
          </Element>
          {/* AMERICANA */}
          <Element name='americana' >
            <SplitSection slides={americaneSlides} reverse>
              <Typography variant='h2' type='title'>AMERICANA</Typography>
              <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
                {americane.description}
              </Typography>
              <Typography padding='1.2rem 0' variant='h3' type='title'>SCHEDA TECNICA</Typography>
              <UList>
                {americane.technical.map((item, i) => <ListItem key={i}>{item}</ListItem>)}
              </UList>
            </SplitSection>
          </Element>
          {/* RETI */}
          <Element name='reti' >
            <SplitSection slides={retiSlides}>
              <Typography variant='h2' type='title'>RETI</Typography>
              <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
                {reti.description}
              </Typography>
              <Typography padding='1.2rem 0' variant='h3' type='title'>SCHEDA TECNICA</Typography>
              <UList>
                {reti.technical.map((item, i) => <ListItem key={i}>{item}</ListItem>)}
              </UList>
            </SplitSection>
          </Element>
        </Content>
        <Section>
          <BigTitle>
            <Typography variant='h2' type='title'>
              4 BUONI MOTIVI PER SCEGLIERE LE NOSTRE STRUTTURE
            </Typography>
          </BigTitle>
          <Features>
            {features.map(feature => (
              <FeatureWrapper>
                <Feature
                  icon={feature.icon}
                  title={feature.title}
                  description={feature.description}
                />
              </FeatureWrapper>
            ))}
          </Features>
        </Section>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    durations: state.calculator.durations,
    products: state.calculator.products
  }
}

export default connect(mapStateToProps, { fetchDurations, fetchProducts })(Contenimento)



// WEBPACK FOOTER //
// ./src/components/Pages/Strutture/Contenimento.js